var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus24Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6958 4.44578C12.6958 4.06151 12.3843 3.75 12 3.75C11.6157 3.75 11.3042 4.06151 11.3042 4.44578V11.3042H4.44578C4.06151 11.3042 3.75 11.6157 3.75 12C3.75 12.3843 4.06151 12.6958 4.44578 12.6958H11.3042V19.5542C11.3042 19.9385 11.6157 20.25 12 20.25C12.3843 20.25 12.6958 19.9385 12.6958 19.5542V12.6958H19.5542C19.9385 12.6958 20.25 12.3843 20.25 12C20.25 11.6157 19.9385 11.3042 19.5542 11.3042H12.6958V4.44578Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus24Regular);
export default __webpack_public_path__ + "static/media/icon_plus_24_Regular.adb47c55.svg";
export { ForwardRef as ReactComponent };